export default __webpack_public_path__ + "maps-examples-multiple-shapes-thumbnail-960-d7fdc3e62da4811abbe59d1aa5d2c39f.png";